// api/log.ts
import axios from 'api';
import { GetLogsParams, LogEntry } from 'redux/log/log.types';

const url = '/api/logs';

const LogAPI = {
  get: (params: GetLogsParams = {}) => axios.get<LogEntry[]>(url, { params }),

  // если бек возвращает тот же формат — используем LogEntry[]
  getClientLogs: (params: Record<string, any>) => axios.get<LogEntry[]>(`${url}/client`, { params }),
};

export default LogAPI;
